export const MapConfig = {
  visualWidth: 24,
  visualHeight: 16,
}


export const UserAddressKey = 'mi_user_address';